import { render, staticRenderFns } from "./centDetails.vue?vue&type=template&id=f4004d12&"
import script from "./centDetails.vue?vue&type=script&lang=js&"
export * from "./centDetails.vue?vue&type=script&lang=js&"
import style0 from "./centDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports